import axios from "axios";
import { baseUrl, portal } from "../App";
import { EVENT_ID } from "../assets/constant";
import { transformDailyWinnerNDataArray, transformWinnerlistDataForBLQuizardArray, transformTournamentWinnerDataArray } from "./transformDataFormat";
import { leaderboardDummyData } from "./dummy-data/leaderboardDummy";

export const fetchLeaderboardByLeaderboarName = async (leaderboardName) => {
  if(!leaderboardName) return [];
  // for daily leaderboard
  if(leaderboardName === 'leaderboard_daily'){
    const res = await axios.get(`${baseUrl}/api/leaderboard/?portal=${portal}&event_id=${EVENT_ID.DAILY_EVENT}`);
    if(res?.data?.length === 0) return leaderboardDummyData.leaderboardDaily;
    return res.data;
  }else if(leaderboardName === 'leaderboard_weekly'){
    const res = await axios.get(`${baseUrl}/api/leaderboard/?portal=${portal}&event_id=${EVENT_ID.WEEKLY_EVENT}`);
    if(res?.data?.length === 0) return leaderboardDummyData.leaderboardWeekly;
    return res.data;
  }else if(leaderboardName === 'leaderboard_tournament'){
    const res = await axios.get(`${baseUrl}/api/leaderboard/?portal=${portal}&event_id=${EVENT_ID.TOURNAMENT_EVENT}`);
    if(res?.data?.length === 0) return leaderboardDummyData.leaderboardTournament;
    return res.data;
  }else if(leaderboardName === 'leaderboard_bcs'){
    const res = await axios.get(`${baseUrl}/api/leaderboard/?portal=${portal}&event_id=${EVENT_ID.BCS_EVENT}`);
    if(res?.data?.length === 0) return leaderboardDummyData.leaderboardBcs;
    return res.data;
  }
  // for last 7 days winner leaderboard
  else if(leaderboardName === 'winner_daily'){
    const res = await axios.get(`${baseUrl}/money/weeklyWinner/?event_id=${EVENT_ID.DAILY_EVENT}`);
    return transformWinnerlistDataForBLQuizardArray(res.data,10);
  }
  else if(leaderboardName === 'winner_weekly'){
    const res = await axios.get(`${baseUrl}/money/weeklyWinner/?event_id=${EVENT_ID.WEEKLY_EVENT}`);
    return transformWinnerlistDataForBLQuizardArray(res.data,10);
  }
  else if(leaderboardName === 'winner_tournament'){
    const res = await axios.get(`${baseUrl}/money/weeklyWinner/?event_id=${EVENT_ID.TOURNAMENT_EVENT}`);
    return transformWinnerlistDataForBLQuizardArray(res.data,10);
  }
  else if(leaderboardName === 'winner_bcs'){
    const res = await axios.get(`${baseUrl}/money/weeklyWinner/?event_id=${EVENT_ID.BCS_EVENT}`);
    return transformWinnerlistDataForBLQuizardArray(res.data,10);
  }

  // for yesterday winner leaderboard
  // https://api.bl.quizard.live/money/dailyWinnerNData/?event_id=75
  else if(leaderboardName === 'winner_y_daily'){
    const res = await axios.get(`${baseUrl}/money/dailyWinnerNData/?event_id=${EVENT_ID.DAILY_EVENT}`);
    return transformDailyWinnerNDataArray(res.data,50);
  }
  else if(leaderboardName === 'winner_y_weekly'){
    const res = await axios.get(`${baseUrl}/money/dailyWinnerNData/?event_id=${EVENT_ID.WEEKLY_EVENT}`);
    return transformDailyWinnerNDataArray(res.data,40);
  }
  else if(leaderboardName === 'winner_y_tournament'){
    const res = await axios.get(`${baseUrl}/money/dailyWinnerNData/?event_id=${EVENT_ID.TOURNAMENT_EVENT}`);
    return transformDailyWinnerNDataArray(res.data,20);
  }
  else if(leaderboardName === 'winner_y_bcs'){
    const res = await axios.get(`${baseUrl}/money/dailyWinnerNData/?event_id=${EVENT_ID.BCS_EVENT}`);
    return transformDailyWinnerNDataArray(res.data,30);
  }

  // tournament top scorer leaderboard
  else if(leaderboardName === 'winner_t_tournament'){
    // https://api.bl.quizard.live/money/topWinnerData/?event_id=150
    const res = await axios.get(`${baseUrl}/money/topWinnerData/?event_id=${EVENT_ID.TOURNAMENT_EVENT}`);
    if(res?.data?.length === 0) return [];
    return transformTournamentWinnerDataArray(res.data,20);
  }
  else{
    return [];
  }
}